import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/NavigationBar'
import EventCard from '../../components/EventCard';
import styles from '../../styles/Home.module.scss'; 
import { Axios } from '../../App';

type TEventData = {
  id?: string,
  name?: string,
  logo?: string,
  background_color?: string,
  font_color?: string
}

const Home = () => {
  const navigate = useNavigate();

  const [events, setEvents] = useState([]);

  const getAllEvents = () => {
    return Axios.get("events/getAll.php").then(({ data }) => {
      setEvents(data);
    });
  };

  useEffect(() => {
    const getQueries = async () => {
      await getAllEvents();
    };

    getQueries();
  }, []);
  return (
    <article>
        <Navbar />
        <div className={styles.wrapper}>
        {events.map((event: TEventData, index) => {
          return (
            <EventCard
              key={index}
              onClick={() => navigate(`/${event.id}/event-manager`)}
            >
              <span>{event.name}</span>
            </EventCard>
          );
      })}
      </div>
    </article>
  )
}

export default Home